import {RecordForm} from '../forms/RecordForm';


import {useRegistration} from '../hooks/useRegistration.ts';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {FormPageLayout} from "@flexinet/ui-components";


export const AddPage = () => {

    const {
        record,
        createRecord,
    } = useRegistration();

    return (
        <FormPageLayout
            title='Add Registration'
            pageNavigation={<IndexPageNavigation/>}
        >
            <RecordForm record={record} handleSubmit={createRecord}/>
        </FormPageLayout>
    );
};
